import { ReactComponent as Theme } from '../assets/illustrations/theme.svg'
import { ReactComponent as ListEdit } from '../assets/illustrations/user-list-illustration.svg'

import React from "react";
import { renderToStaticMarkup } from "react-dom/server";

const tokens = {
  theme: {
    default: `url("data:image/svg+xml;utf8,${encodeURIComponent(renderToStaticMarkup(<Theme />))}")`,
    "scenario-edit": `url("data:image/svg+xml;utf8,${encodeURIComponent(renderToStaticMarkup(<ListEdit />))}")`,
  },
}
export default { ...tokens }
